/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import styled from 'styled-components';

export const NewsViewContainerStyled = styled.div`
    max-width: 640px;
    height: 100%;
    padding: 24px 0 0 38px;
`;
